import { ofType } from 'redux-observable';
import { concat, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { TYPE_SUCCESS } from '../../constants/snackbar';

import { gqlRequest } from '../../helpers/request';
import { getUser } from '../../helpers/user';
import * as commonSelectors from '../selectors/common';
import { cancelFavoritesUpdatingAction, deleteFavoritesAction, setFavoritesAction } from '../slices/common';
import { notifyAction } from '../slices/snackbar';

const queryGQL = `
  mutation hostedWatchDeleteFavorites(
    $mediaid: String,
  ) {
    hostedWatchDeleteFavorites(
      mediaid: $mediaid,
    )
  }
`;

export default (action$, state$) =>
  action$.pipe(
    ofType(deleteFavoritesAction.type),
    mergeMap(({ payload }) =>
      gqlRequest({
        query: queryGQL,
        variables: {
          mediaid: payload,
        },
      }).pipe(
        mergeMap(({ errors }) => {
          const actions = [];
          if (!errors.length) {
            const favoritesVideo = commonSelectors.favoritesVideoSelector(state$.value).slice();
            const updatedFavorites = favoritesVideo.filter((mediaid) => mediaid !== payload);

            actions.push(of(setFavoritesAction(updatedFavorites)));

            const { accountId } = getUser();
            if (accountId) {
              actions.push(of(notifyAction({ variant: TYPE_SUCCESS, message: 'Video removed from Favorites' })));
            }
          } else {
            actions.push(of(cancelFavoritesUpdatingAction()));
          }

          return concat(...actions);
        }),
      ),
    ),
  );
